import React from 'react'
import './Icon.scss'
const rootClassName = 'icon-component'

export const LockIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.20127 7.96143H4.75829C3.73267 7.96143 2.90039 8.79557 2.90039 9.82443V22.1374C2.90039 23.1656 3.73296 24.0004 4.75829 24.0004H19.2425C20.2685 24.0004 21.1004 23.1659 21.1004 22.1374V9.82443C21.1004 8.79529 20.2688 7.96143 19.2425 7.96143H16.7999V4.81243C16.7999 2.15444 14.6511 0.000427246 12.0001 0.000427246C9.3499 0.000427246 7.20127 2.15461 7.20127 4.81243V7.96143ZM8.19853 7.96143H15.8026V4.81243C15.8026 2.7068 14.1004 1.00043 12.0001 1.00043C9.90064 1.00043 8.19853 2.70693 8.19853 4.81243V7.96143ZM16.3013 8.96143H19.2425C19.718 8.96143 20.1031 9.34757 20.1031 9.82443V22.1374C20.1031 22.6137 19.7176 23.0004 19.2425 23.0004H4.75829C4.28373 23.0004 3.89765 22.6133 3.89765 22.1374V9.82443C3.89765 9.34797 4.28333 8.96143 4.75829 8.96143H7.6999H16.3013Z'
      />
    </svg>
  )
}
